<template>
	<div class="skeleton"><slot /></div>
</template>

<style scoped>
.skeleton {
	height: 1em;
	overflow: hidden;
	position: relative;
	background-color: var(--secondary-background-color);
	border-radius: var(--size-xs);
}

.skeleton::after {
	content: '';
	animation: skeleton-animation 1.3s infinite;
	height: 100%;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	transform: translateX(-100%);
	z-index: 1;
	background: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, 0.3), transparent);
}

@keyframes skeleton-animation {
	from {
		transform: translateX(-100%);
	}
	to {
		transform: translateX(100%);
	}
}
</style>
